
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import StatusLegend from "./StatusLegend";

interface TimeSlotsProps {
    appointmentDate: string;
    id: string;
    setSelectedSlotID: (id: string) => void;
}

interface TimeSlot {
    status: number;
    slot: string;
    slotId: string;
}
const currentTime = dayjs();
function convertToDayjs(timeStr: any) {
    return dayjs(timeStr, 'hh:mm A');
}
const statusData = [
    {
        label: "Available",
        color: "rgba(5, 95, 252, 1)",
    },
    {
        label: "Booked",
        color: "rgba(201, 201, 201, 1)",
    },
    {
        label: "Selected",
        color: "rgba(81, 184, 0, 1)",
    },
    {
        label: "Expired",
        color: "rgba(255, 99, 71, 1)",
    }
];

const TimeSlots: React.FC<TimeSlotsProps> = ({ appointmentDate, id, setSelectedSlotID }) => {
    const [timeSlots, setTimeSlots] = useState<TimeSlot[]>([]);
    const [selectedSlotId, setSelectedSlotId] = useState<string | null>(null);
    const [messageshown, setMessageShown] = useState<string | null>(null);
    const today = dayjs().startOf('day');
    const someOtherDate = dayjs(appointmentDate).startOf('day');
    const isSameDay = today.isSame(someOtherDate, 'day');
    const theme = useTheme();
    const isxsdown = useMediaQuery(theme.breakpoints.down('sm'));
    const fetchTimeSlots = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/time-slots/get_all_time_slots?doctorId=${id}&date=${appointmentDate}`, {
                method: 'GET',
                headers: {
                    'accept': '*/*',
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                }
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            if (data?.isSuccess) {
                data?.data.forEach((obj: any) => {
                    const [startTime, endTime] = obj.slot.split(' - ');
                    const startdate = convertToDayjs(startTime);
                    if (currentTime.isAfter(startdate)) {
                        if (obj.status === 1) {

                        } else if (isSameDay) {
                            obj.status = 2
                        }
                    }
                });
                setTimeSlots(data?.data || []);
            } else {
                setMessageShown(data?.message)
                toast.error(data?.message)
                setTimeSlots([])
            }


        } catch (error) {
            console.error('Failed to fetch time slots:', error);
        }
    };

    useEffect(() => {
        if (id && appointmentDate) {
            fetchTimeSlots();
        }
    }, [appointmentDate]);

    const handleSlotClick = (slotId: string) => {
        const selectedSlot = timeSlots.find(slot => slot.slotId === slotId);
        if (!selectedSlot || selectedSlot.status) return;

        if (selectedSlotId) {
            setTimeSlots(prevSlots =>
                prevSlots.map(slot =>
                    slot.slotId === selectedSlotId
                        ? { ...slot, status: 0 }
                        : slot
                )
            );
        }
        setSelectedSlotId(slotId);
        setSelectedSlotID(slotId);
        setTimeSlots(prevSlots =>
            prevSlots.map(slot =>
                slot.slotId === slotId
                    ? { ...slot, status: 0 }
                    : slot
            )
        );
    };

    return (
        <>
            {isxsdown && (
                <StatusLegend statusData={statusData} />
            )}
            {!isxsdown && (

                <Typography variant="h4" sx={{ fontSize: "12px", fontWeight: "600" }}>
                    Select Time Slot
                </Typography>
            )}
            <Box sx={{
                marginTop: "2px",
                borderRadius: "14px", border: "1px solid gray", p: 1.5, height: "60vh", overflowY: "auto", "&::-webkit-scrollbar": {
                    width: "6px",

                },
                "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#077DD3",
                },
                "&::-webkit-scrollbar-track": {
                    backgroundColor: "rgba(7, 125, 211, 0.24)",
                },
            }}>
                <Box sx={{ display: "flex", gap: "5px", flexWrap: "wrap", justifyContent: { sm: "flex-start", xs: "center" } }}>
                    {timeSlots.length > 0 ? (
                        timeSlots.map((slot) => (
                            <Box
                                key={slot.slotId}
                                onClick={() => handleSlotClick(slot.slotId)}
                                sx={{
                                    border: slot.status === 2 ? "1px dashed rgba(255, 99, 71, 1)" : (slot.status ? "1px dashed rgba(201, 201, 201, 1)" : "1px dashed rgba(0, 87, 239, 1)"),
                                    p: { xs: 0, sm: 0, md: 1 },
                                    width: "149px",
                                    height: "38px",
                                    fontSize: "12px",
                                    borderRadius: "6px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: slot.slotId === selectedSlotId
                                        ? "rgba(81, 184, 0, 1)"
                                        : (slot.status === 2 ? "rgba(255, 99, 71, 1)" : (slot.status ? "rgba(201, 201, 201, 1)" : "rgba(5, 95, 252, 1)")),
                                    backgroundColor: slot.slotId === selectedSlotId
                                        ? "rgba(81, 184, 0, 0.1)"
                                        : (slot.status === 2 ? "rgba(255, 99, 71, 0.1)" : (slot.status ? "rgba(201, 201, 201, 0.1)" : "rgba(5, 95, 252, 0.1)")),
                                    fontWeight: "600",
                                    cursor: slot.status === 2 ? "not-allowed" : (slot.status ? "not-allowed" : "pointer"),
                                }}
                            >
                                {slot.slot}
                            </Box>
                        ))
                    ) : (
                        <p className="font-bold"
                        >
                            {messageshown ? messageshown : "Select the Doctor name to get time slots"}
                        </p>
                    )}
                </Box>
            </Box >
        </>
    );
}

export default TimeSlots;
